/*eslint-disable */
import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES } from "../../../utils/constant";

class RouteMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: "routeMaster" })
      .then((dataArray) => {
        console.log(dataArray);
        this.setState({
          rowData: isEmpty(dataArray) ? [] : dataArray.data.resultSet,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_CHECKPOINT_MASTER.UPDATE == true) {
      typeof rowData.value != "undefined" && this.onRowEdit(rowData.data);
    }
  };

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-route", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/route");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    var rowItems = [];
    rowData.map((object, i) => {

      let temp = {};
      temp.routeMasterId = object.routeMasterId;
      temp.routeCode = object.routeCode;
      temp.routeName = object.routeCheckPointNames.split(",");
      temp.routeNamet = object.routeName;
      temp.fromRoute = temp.routeName[0];
      temp.toRoute = temp.routeName[temp.routeName.length -1];
      temp.routeDescription = object.routeDescription;
      temp.budgetedRouteTat = object.budgetedRouteTat;
      temp.budgetedRouteKm = object.budgetedRouteKm;
      temp.createdBy = object.createdBy;
      temp.createdOn = object.createdOn;
      temp.updatedBy = object.updatedBy;
      temp.updatedOn = object.updatedOn;
      rowItems[i] = temp;
    });
    const Columns = [
      {
        headerName: t("table_header.route_code") || "Route Code",
        field: "routeCode",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.route_from") || "Source",
        field: "fromRoute",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.route_to") || "Destination",
        field: "toRoute",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.route_description") || "Route Description",
        field: "routeDescription",
        sortable: true,
        filter: true,
      },
      // { headerName: "Source", field: "skuName", sortable: true, filter: true },
      // { headerName: "Destination", field: "noUnitSku", sortable: true, filter: true },
      {
        headerName: t("table_header.budgeted_time") || "Budgeted Time",
        field: "budgetedRouteTat",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.budgeted_distance") || "Budgeted Distance",
        field: "budgetedRouteKm",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_ROUTE_MASTER.UPDATE && !this.props.permissions.TA_ROUTE_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowItems}
          titleBarTitle={this.props.t("title") || "Route"}
          titleBarLink={"/add-route"}
          baseURL={"routeMaster"}
          pathName={"routeMaster"}
          keyIndex={"routeMasterId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_ROUTE_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_ROUTE_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("route")(RouteMaster));
